<template>
  <v-tooltip bottom x-small :class="classContainer">
    <template v-slot:activator="{ on, attrs }">
      <v-icon :color="iconColor" dark :size="iconSize" v-bind="attrs" v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span v-html="text"></span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    classContainer: {
      type: String,
    },
    iconSize: {
      type: String,
      default: "18",
    },
    iconColor: {
      type: String,
      default: "#007185",
    },
  },
};
</script>

<style></style>
